import Brands from 'components/Pages/Brands/Brands';

export default Brands;
